/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useCallback } from 'react';
import { ApiConfigration } from '@/hotdesk-ui/common-classes/api-configuration';
import { ListingService } from '@/hotdesk-ui/services/listing.service';
import { parseData } from '@/hotdesk-ui/helpers/utils';
interface useListingsFetchParams {
    workspaceId: number;
    languageCode: string;
    token: string | null;
}

export interface WorkspaceWithDistance {
    id: number;
    title: string;
    slug?: string;
    workspaceCity?: {
        name: string;
        country?: {
            slug: string;
            name: string;
        };
    };
    location?: {
        coordinates: number[];
    };
    metaData?: any;
    rules?: any;
    status?: number;
    distance?: number;
}



export const useListingsFetch = ({
    workspaceId,
    languageCode,
    token,
}: useListingsFetchParams) => {
    const [listings, setListings] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [currentOffset, setCurrentOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const fetchListings = useCallback(
        async (limit: number, offset: number, isLoadMore: boolean = false) => {
            if (isLoadMore) {
                setLoadingMore(true);
            } else {
                setLoading(true);
            }
            setError(false);

            try {
                const apiConfig = await new ApiConfigration().getApiConfig(
                    languageCode,
                    token ?? ''
                );
                const listingService = new ListingService(apiConfig);
                const response = await listingService.getallListings({
                                        limit,
                                        offset,
                                        workspaceId: workspaceId,
                                        status: '1'
                                    });
                if (response.results && response.results.length > 0) {
                    const listingResults = parseData(response.results);
                    if (isLoadMore) {
                        setListings((prev) => [...prev, ...listingResults]);
                    } else {
                        setListings(listingResults);
                    }

                    setTotalCount(response.count || 0);
                    setCurrentOffset(offset + listingResults.length);
                    setHasMore(
                        listingResults.length === limit &&
                            offset + listingResults.length <
                                (response.count || 0)
                    );
                } else {
                    if (!isLoadMore) {
                        setListings([]);
                        setTotalCount(0);
                    }
                    setHasMore(false);
                }
            } catch (err) {
                console.error('Error fetching listings:', err);
                setError(true);
            } finally {
                if (isLoadMore) {
                    setLoadingMore(false);
                } else {
                    setLoading(false);
                }
            }
        },
        [workspaceId,languageCode, token]
    );

    const loadMore = useCallback(() => {
        if (!loadingMore && hasMore) {
            fetchListings(10, currentOffset, true);
        }
    }, [currentOffset, loadingMore, hasMore, fetchListings]);

    const reset = useCallback(() => {
        setListings([]);
        setLoading(false);
        setLoadingMore(false);
        setError(false);
        setTotalCount(0);
        setCurrentOffset(0);
        setHasMore(true);
    }, []);

    return {
        listings,
        loading,
        loadingMore,
        error,
        totalCount,
        hasMore,
        fetchListings,
        loadMore,
        reset
    };
};
